import * as React from "react";
import { Mask, EditForm } from "../../../styles/DeviceList";
import type { SetState, Fn } from "../../../client_types";
interface IUpdateValue {
  Gid: string;
  DeviceUUID: string;
  Did: string;
  DeviceName: string;
}
interface IProps {
  editable: boolean;
  updateValue: IUpdateValue;
  setEditable: SetState<boolean>;
  setUpdateValue: SetState<IUpdateValue>;
  updateDevice: Fn;
}

const EditableForm = ({
  editable,
  updateValue,
  setEditable,
  setUpdateValue,
  updateDevice,
}: IProps) => (
  <>
    {editable ? (
      <>
        <Mask editable />
        <EditForm>
          <label htmlFor="nameNew">
            踏板名称
            <input
              type="text"
              name="nameNew"
              id="nameNew"
              defaultValue={updateValue.DeviceName}
              onChange={(e) =>
                setUpdateValue({ ...updateValue, DeviceName: e.target.value })
              }
            />
          </label>
          <label htmlFor="uuidNew">
            踏板ID
            <input
              type="text"
              name="uuidNew"
              id="uuidNew"
              defaultValue={updateValue.DeviceUUID}
              onChange={(e) =>
                setUpdateValue({ ...updateValue, DeviceUUID: e.target.value })
              }
            />
          </label>
          <div className="btnGroup">
            <button className="btn" onClick={updateDevice}>
              确认
            </button>
            <button className="btn cancel" onClick={() => setEditable(false)}>
              取消
            </button>
          </div>
        </EditForm>
      </>
    ) : null}
  </>
);

export default EditableForm;
